/**
 * The Knowledge page's route search vocabulary, kept out of the page module so the two routes can
 * register `validateSearch` without pulling the lazy page into the entry chunk.
 */

/** Search params the Knowledge page selects by: `?page=<id>&section=<id>`. */
export const KNOWLEDGE_PAGE_KEY = 'page';
export const KNOWLEDGE_SECTION_KEY = 'section';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `page` and `section` are ids; a section without its page means nothing, and anything else is dropped. */
export function validateKnowledgeSearch(search: Record<string, unknown>): Record<string, string> {
  const page = search[KNOWLEDGE_PAGE_KEY];
  if (typeof page !== 'string' || !UUID.test(page)) return {};
  // Lower case, as the server writes ids: the page's cache key is the same however the link was typed.
  const section = search[KNOWLEDGE_SECTION_KEY];
  return typeof section === 'string' && UUID.test(section)
    ? { [KNOWLEDGE_PAGE_KEY]: page.toLowerCase(), [KNOWLEDGE_SECTION_KEY]: section.toLowerCase() }
    : { [KNOWLEDGE_PAGE_KEY]: page.toLowerCase() };
}
